<style scoped lang="scss" src="./WrongBrowser.scss"></style>
<template>
  <section class="wrong-browser-container">
    <main class="wrong-browser-container__content" v-if="true">
      <div class="title secondmain">Oh não...</div>
      
      <div class="title" v-if="!isFirefox">Seu navegador está desatualizado</div>
      <div class="title" v-if="isFirefox">Seu navegador não está habilitado para o nosso sistema</div>
      
      <figure class="icon">
        <IconWrongBrowser />
      </figure>
      
      <div class="text">
        Para continuar utilizando nosso sistema, é necessário baixar o nosso aplicativo - 
        <span class="highlight">Minha Consulta</span>.
      </div>
      
      <div class="text computer">
        Para baixar a nova versão, basta
        <span class="highlight pointer" @click="openBrowserDesktop">
          clicar aqui para ir para a loja da Google
        </span>.
      </div>
      <footer class="footer">
        <div class="text">Clique no botão abaixo para realizar a instalação:</div>
        <div class="acts">
          <div class="box" @click="openGoogleStore">
            <div class="label">Ir para a Play Store</div>
          </div>
        </div>
      </footer>
    </main>
  </section>
</template>

<script>
import IconAppStore from "@/views/patient/main/components/IconAppStore.vue";
import IconWrongBrowser from "@/views/patient/main/components/IconWrongBrowser.vue";
import IconPlayStore from "@/views/patient/main/components/IconPlayStore.vue";

export default {
  name: "WrongBrowser" ,
  components: {IconPlayStore, IconWrongBrowser, IconAppStore},
  props:{
    browserVersion:String,
    browserName:String
  },
  
  computed: {
    isFirefox () {
      return this.browserName === 'Mozilla Firefox'
    }
  },

  methods:{
    openGoogleStore() {
      window.open(
          "https://play.google.com/store/apps/details?id=com.a4pm.minhaconsulta",
          "_blank",
          "noopener"
      );
    },
    openBrowserDesktop() {
      window.open("https://www.google.com/intl/pt-BR/chrome/", "_blank", "noopener");
    },
  }
}
</script>

